import React, { FunctionComponent } from 'react';
import { Trans } from 'react-i18next';
import Avatar from '@jg/avatar';
import { ICaptain } from '../../types/state.d';
import { makePhotoUrl } from '../../utils';

type Props = {
  captain: ICaptain;
};

const CaptainCard: FunctionComponent<Props> = ({
  captain: { profileImage, firstName, lastName },
}) => (
  <li className="jg-space-pbsm jg-tc-member-card">
    <div className="jg-display-flex">
      <Avatar
        avatarSize="large"
        picture={makePhotoUrl(profileImage as string)}
      />
      <div className="jg-space-mlms jg-display-flex container--flex--column">
        <span className="jg-h5">{`${firstName} ${lastName}`}</span>
        <span className="jg-color--empress jg-text--medium-regular ">
          <Trans i18nKey="content.editmembers.teamCaptain" />
        </span>
      </div>
    </div>
  </li>
);

export default CaptainCard;
